import {
  type UserAddUserBankAccountInput,
  type UserGetUserBankAccountsInput,
  type UserSetDefaultUserBankAccountInput,
} from '../api'
import { api } from '../api'

const create = async (data: UserAddUserBankAccountInput) => {
  return await api.v1.userAddUserBankAccount({
    ...data,
  })
}

const get = async (data: UserGetUserBankAccountsInput) => {
  return await api.v1.userListUserBankAccounts({
    ...data,
  })
}

const remove = async (ids: number[]) => {
  return await api.v1.userDeleteBankAccounts({
    ids,
  })
}

const setDefault = async (data: UserSetDefaultUserBankAccountInput) => {
  return await api.v1.userSetDefaultUserBankAccount({
    ...data,
  })
}

export default {
  create,
  get,
  remove,
  setDefault,
}
